import { gql } from '../../../apollo/__generated__';

export const MY_UNTINDERED_USERS = gql(`
  query MyUntinderedUsers($eventId: ID!) {
    myUntinderedUsers(eventId: $eventId) {
      id
      firstname
      nickname
      studies
      studyTown
      images {
        id
        url
      }
    }
  }
`);
